/** Marque la zone qui défile dans le cadre d'application (essai TEC-1956) : la surface du contenu. */
export const APP_SCROLL_CONTAINER_ATTR = 'data-app-scroll-container'

/**
 * Remonte en haut du contenu : la surface du cadre quand elle défile, la fenêtre sinon (écrans sans cadre,
 * mobile). `window.scrollTo` seul ne fait plus rien dans le cadre, où la fenêtre ne défile pas.
 */
export function scrollAppToTop(behavior: ScrollBehavior = 'smooth') {
  const container = document.querySelector<HTMLElement>(
    `[${APP_SCROLL_CONTAINER_ATTR}]`
  )
  ;(container ?? window).scrollTo({ top: 0, behavior })
}
